import { render, staticRenderFns } from "./next.vue?vue&type=template&id=824eaf6a&scoped=true"
import script from "./next.vue?vue&type=script&lang=js"
export * from "./next.vue?vue&type=script&lang=js"
import style0 from "./next.vue?vue&type=style&index=0&id=824eaf6a&prod&lang=scss&scoped=true"
import style1 from "./next.vue?vue&type=style&index=1&id=824eaf6a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "824eaf6a",
  null
  
)

export default component.exports